import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Evaluation} from '../../../forms/modules/sp/models/saavs';

@Pipe({
  name: 'filterSearchSpEvaluation'
})
export class FilterSearchSpEvaluationPipe implements PipeTransform {

  constructor(private cdr: ChangeDetectorRef, private translate: TranslateService) {
  }

  transform(items: Evaluation[], searchText: string, evaluationsFilterMetadata): Evaluation[] {
    if (!items) {
      evaluationsFilterMetadata.count = 0;
      this.cdr.detectChanges();
      return [];
    }
    if (!searchText) {
      evaluationsFilterMetadata.count = items.length;
      this.cdr.detectChanges();
      return items;
    }
    searchText = searchText.toLowerCase();

    const filteredItems = items.filter((evaluation: Evaluation) => {
      let text = new Date(evaluation.evaluationDate).toLocaleDateString().replace(/\s/g, '') + ' ' + evaluation.idUser + ', ';
      text += evaluation.summary.slice(0, 50);
      return text.toLowerCase().indexOf(searchText) !== -1;
    });
    evaluationsFilterMetadata.count = filteredItems.length;
    this.cdr.detectChanges();
    return filteredItems;
  }


}
